module.exports = __webpack_public_path__ + "img/logo.a86ae5c1.png";